/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2017, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
angular.module('bulbApp.commentModule').service(
  'BulbCommentService',
  ['$compile', '$document', '$q', '$rootScope', '$timeout', '$window', 'BulbAuthService',
    'BulbErrorService', 'BulbModalService', 'BulbPresentationService', 'SerialSaveService', 'Restangular', 'AUTH',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    BulbCommentService],
);

function BulbCommentService(
  $compile,
  $document,
  $q,
  $rootScope,
  $timeout,
  $window,
  BulbAuthService,
  BulbErrorService,
  BulbModalService,
  BulbPresentationService,
  SerialSaveService,
  Restangular,
  AUTH,
) {
  const that = this;
  let currentPageElement = null;

  this.currentPage = null;
  this.authorFlg = false;
  this.currentTargetId = null;
  this.nodeType = null;
  this.currentMediumEditor = null;
  this.commentThreadMap = null;
  this.threadComment = {};
  this.lowerCommentExpanded = {};
  this.sideQuotationExpanded = {};
  this.lowerQuotationExpanded = {};
  this.targetList = null;
  this.editorType = null;

  this.defaultThreadId = null;
  // FUTURE JDK BULB-2859 : This is temporarily disabled until the custom work for CKEditor commenting is completed.
  this.showArchivedComments = false; // BulbAuthService.currentUser.prefs.showArchivedComments;

  this.isSideCommentEnabled = function isSideCommentEnabled() {
    // In the current design, you need a screen width of 1320 to display comments on the side.
    return jQuery($window).width() >= 1320;
  };

  this.setDefaultThread = function setDefaultThread(threadId) {
    this.defaultThreadId = threadId;
  };

  this.getPageElementHeight = function getPageElementHeight() {
    if (that.editorType === 'ckeditor') {
      return $('.ck-content').height();
    }
    return currentPageElement.height();
  };

  this.pageHasPrivateComments = function pageHasPrivateComments() {
    return that.pageHasCommentType('private');
  };

  this.pageHasArchivedComments = function pageHasArchivedComments() {
    return that.pageHasCommentType('archived');
  };

  this.pageHasCommentType = function pageHasCommentType(str) {
    if (!that.commentThreadMap) {
      return false;
    }

    for (let i = 0; i < Object.keys(that.commentThreadMap).length; i += 1) {
      const currentKey = Object.keys(that.commentThreadMap)[i];
      const commentEntries = that.commentThreadMap[currentKey].filter((comment) => { // jshint ignore:line
        if (str === 'private') {
          return comment.privateComment === true;
        }
        return comment.archived === true;
      });

      if (commentEntries.length > 0) {
        return true;
      }
    }

    return false;
  };

  // FUTURE JDK BULB-2859 : This is temporarily modified to hide private comments in the comment count until the
  // custom work for CKEditor commenting is completed.
  this.getPageCommentsCount = function getPageCommentsCount() {
    let totalComments = 0;

    // If the commentThreadMap is null, just return 0.
    if (!that.commentThreadMap) {
      return totalComments;
    }

    for (let i = 0; i < Object.keys(that.commentThreadMap).length; i += 1) {
      const currentKey = Object.keys(that.commentThreadMap)[i];
      // totalComments += that.commentThreadMap[currentKey].length;
      // FUTURE JDK BULB-2859 : Remove code bellow this and re-enable the above line
      const commentEntries = that.commentThreadMap[currentKey].filter((comment) => comment.privateComment === false);

      totalComments += commentEntries.length;
    }

    return totalComments;
  };

  let requestingContentCount = 0;
  $rootScope.$on('$includeContentLoaded', () => {
    requestingContentCount -= 1;
  });
  $rootScope.$on('$includeContentRequested', () => {
    requestingContentCount += 1;
  });

  // API calling
  this.api = {

    // API common process
    updateInternalData(res) {
      that.updateCommentThreadMap(res);

      // Show the specific comment thread.
      if (that.defaultThreadId) {
        let tmpTargetId = null;
        let tmpThreadIdx = 0;
        for (const targetId in that.commentThreadMap) {
          const threadList = that.commentThreadMap[targetId];

          for (let i = 0; i < threadList.length; i += 1) {
            if (threadList[i].id === that.defaultThreadId) {
              tmpTargetId = targetId;
              tmpThreadIdx = i;
            }
          }
        }

        that.currentTargetId = null;
        if (that.isSideCommentEnabled()) {
          that.updateCommentThreads(tmpTargetId, tmpThreadIdx, nodeType);
        } else {
          const tmpThreadId = that.defaultThreadId;
          that.lowerCommentExpanded[that.defaultThreadId] = true;
          let tmp;
          const repositioner = function repositioner() {
            if (requestingContentCount === 0 && tmp) {
              tmp();
              tmp = null;
              that.lowerScrollTargetId = tmpThreadId;
            }
          };
          tmp = $rootScope.$on('$includeContentLoaded', repositioner);
        }
        that.defaultThreadId = null;
      }
      return res;
    },

    // get all threads
    getAllThreads() {
      return Restangular.one('comment', that.currentPage.unit.id).all('thread').all('all').get('', {})
        .then(
          that.api.updateInternalData,
        );
    },

    // create blank thread
    createBlankThread(targetId) {
      return SerialSaveService.save({
        save: () => Restangular.one('comment', that.currentPage.unit.id).all('thread').all('createblank').get('', {
          targetId,
        }),
      });
    },

    // create thread
    createThread(targetId, quotation, comment, isCommentPrivate) {
      return SerialSaveService.save({
        save: () => Restangular.one('comment', that.currentPage.unit.id).all('thread').all('create')
          .post({
            targetId,
            quotation,
            comment,
            isCommentPrivate,
          })
          .then(that.api.updateInternalData),
      });
    },

    // delete thread
    deleteThread(thread) {
      return SerialSaveService.save({
        save: () => Restangular.one('comment', that.currentPage.unit.id).one('thread', thread.id).remove({
          targetId: thread.targetId,
        }).then(that.api.updateInternalData),
      });
    },

    // archive thread
    archiveThread(thread, archived) {
      return SerialSaveService.save({
        save: () => Restangular.one('comment', that.currentPage.unit.id).one('thread', thread.id).all('archive')
          .patch('', {
            targetId: thread.targetId,
            archived,
          })
          .then(() => {
            // eslint-disable-next-line no-param-reassign
            thread.archived = archived;
          }),
      });
    },

    // comment paragraph
    comment(thread, comment, isCommentPrivate) {
      return SerialSaveService.save({
        preventRetry: true,
        save: () => Restangular.one('comment', that.currentPage.unit.id).one('thread', thread.id).all('comment')
          .post({
            targetId: thread.targetId,
            comment,
            isCommentPrivate,
          })
          .then(that.api.updateInternalData),
      }).catch((error) => {
        if (error.status === 404) {
          BulbModalService.show({
            fontAwesomeCode: 'fas fa-comment-exclamation',
            titleCode: 'modal_oops_title',
            bodyCode: 'comment_thread_not_found_body',
            cancelButtonCode: 'button_continue',
            showCancelButton: false,
            windowClass: 'updated-modal-design bulb-aero-modal',
          });
        }
      });
    },

    // comment page
    commentPage(comment, isCommentPrivate) {
      return SerialSaveService.save({
        save: () => Restangular.one('comment', that.currentPage.unit.id).all('comment').post({
          comment,
          isCommentPrivate,
        }).then(that.api.updateInternalData),
      });
    },

    // update comment
    updateComment(thread, commentId, commentContent) {
      return SerialSaveService.save({
        save: () => Restangular.one('comment', that.currentPage.unit.id).one('thread', thread.id).one(
          'comment',
          commentId,
        ).patch({
          targetId: thread.targetId,
          comment: commentContent,
        }),
      });
    },

    // delete comment
    deleteComment(thread, commentId) {
      return SerialSaveService.save({
        save: () => Restangular.one('comment', that.currentPage.unit.id).one('thread', thread.id).one(
          'comment',
          commentId,
        ).remove({
          targetId: thread.targetId,
        })
          .then(that.api.updateInternalData),
      });
    },

    // mark comment read
    markCommentRead(thread, commentId) {
      return SerialSaveService.save({
        save: () => Restangular.one('comment', that.currentPage.unit.id).one('thread', thread.id).one(
          'comment',
          commentId,
        ).all('read')
          .patch('', {
            targetId: thread.targetId,
          }),
      });
    },

    // get paragraph ids
    getParagraphIds(count) {
      return Restangular.all('id').post('', {
        count,
      });
    },

    // update account preference
    updateAccountPreferences() {
      // eslint-disable-next-line no-param-reassign
      BulbAuthService.currentUser.prefs.showArchivedComments = that.showArchivedComments;

      return Restangular.one('accounts', BulbAuthService.currentUser.id).patch({
        prefs: BulbAuthService.currentUser.prefs,
      }).catch((error) => {
        BulbErrorService.error('Cannot update the user preferences', error);
      });
    },
  };

  const getThread = function getThread(tmpCommentThreadMap, targetId, threadId) {
    const threadList = tmpCommentThreadMap[targetId];
    for (const i in threadList) {
      if (threadList[i].id === threadId) {
        return threadList[i];
      }
    }
    return null;
  };

  const addDraftThread = function addDraftThread() {
    if (!that.draftThread) {
      return;
    }
    const targetId = that.currentTargetId;
    if (!that.commentThreadMap[targetId]) {
      that.commentThreadMap[targetId] = [];
    }
    that.commentThreadMap[targetId].unshift(that.draftThread);
  };

  const removeDraftThreadFromThreadMap = function removeDraftThreadFromThreadMap() {
    if (!that.draftThread) {
      return;
    }
    const list = that.commentThreadMap[that.currentTargetId];
    if (list && list.length && list[0].draft) {
      list.shift();
      that.draftThread = null;
    }
  };

  // update targetExist and targetList
  const updateTargetExistence = function updateTargetExistence() {
    const targetTop = [];
    let top = -1;
    for (const targetId in that.commentThreadMap) {
      let target;
      if (that.editorType === 'ckeditor') {
        target = that.findCKETargetElement(targetId);
        if (target) {
          top = target.offsetTop;
        }
      } else {
        target = document.getElementById(targetId);
        if (target) {
          top = target.offsetTop;
        }
      }
      targetTop.push({
        targetId,
        top,
      });

      const exist = !!target;
      const threadList = that.commentThreadMap[targetId];
      for (const idx in threadList) {
        threadList[idx].targetExist = exist;
      }
    }

    targetTop.sort((target1, target2) => (target1.top < target2.top ? -1 : 1));

    that.targetList = [];
    targetTop.forEach((target) => {
      that.targetList.push(target.targetId);
    });

    // check current target existence
    if (that.currentTargetId !== null) {
      const list = that.commentThreadMap[that.currentTargetId];
      if (list && list.length > 0 && !list[0].targetExist) {
        that.currentTargetId = null;
        that.draftThread = null;
      }
    }
  };

  this.updateCommentThreadMap = function updateCommentThreadMap(res) {
    const lastScrollTop = $document.scrollTop();
    const newCommentThreadMap = res.commentThreadMap;

    if (that.commentThreadMap) {
      // merge
      let targetId;
      let i;
      let thread;
      let newThread;

      // update and delete thread
      for (targetId in that.commentThreadMap) {
        const threadList = that.commentThreadMap[targetId];
        for (i in threadList) {
          thread = threadList[i];
          newThread = getThread(newCommentThreadMap, targetId, thread.id);
          if (newThread) {
            thread.comments = newThread.comments;
            thread.unread = newThread.unread;
          } else {
            // delete
            threadList.splice(i, 1);
          }
        }
      }

      // add thread
      for (targetId in newCommentThreadMap) {
        const newThreadList = newCommentThreadMap[targetId];
        for (i in newThreadList) {
          newThread = newThreadList[i];
          thread = getThread(that.commentThreadMap, targetId, newThread.id);
          if (!thread) {
            // add
            if (!that.commentThreadMap[targetId]) {
              that.commentThreadMap[targetId] = [];
            }
            that.commentThreadMap[targetId].unshift(newThread);
          }
        }
      }
    } else {
      // set
      that.commentThreadMap = newCommentThreadMap;
    }

    // update targetExist and targetList
    updateTargetExistence();

    addDraftThread();

    that.refreshBubbleButtons();

    // Resetting the scrollTop to what it was when we started updateCommentThreadMap()
    // so that we don't unintentionally change the scroll position of the page as a result of adding any comments.
    $timeout(() => {
      $document.scrollTop(lastScrollTop);
    });
  };

  let cachedNewParagraphIds = [];
  this.getParagraphIds = function getParagraphIds(needs) {
    const deferred = $q.defer();
    const processResult = function processResult() {
      const result = [];
      for (let i = 0; i < needs; i += 1) {
        result.push(cachedNewParagraphIds.pop());
      }
      deferred.resolve(result);
    };

    const cacheMinThreshold = 5;
    const cacheCount = 10;

    if (cachedNewParagraphIds.length >= needs) {
      processResult();
      // cache for future
      if (cachedNewParagraphIds.length <= cacheMinThreshold) {
        that.api.getParagraphIds(cacheCount).then((res) => {
          cachedNewParagraphIds = res;
        });
      }
    } else {
      // cache now
      that.api.getParagraphIds(needs + cacheCount).then((res) => {
        cachedNewParagraphIds = res;
        processResult();
      });
    }

    return deferred.promise;
  };

  this.createCommentThread = function createCommentThread(unit, editor, selectedBlock, ckeEventDetail) {
    let target;
    let targetId;
    let quotation = '';

    if (ckeEventDetail) {
      targetId = ckeEventDetail.id;
      if (ckeEventDetail.text) {
        quotation = ckeEventDetail.text;
      }
    } else {
      if (editor.options.contentWindow.getSelection().rangeCount > 0) {
        target = jQuery(editor.getSelectedParentElement().closest('.bulb-page-content > *'));
        targetId = target.attr('id');
      } else if (selectedBlock) {
        targetId = selectedBlock.id;
        target = jQuery(`#${selectedBlock.id}`);
      }

      if (target.prop('tagName') !== 'CONTENT-BLOCK') {
        const selection = editor.exportSelection();
        quotation = jQuery(editor.getFocusedElement()).text().substring(selection.start, selection.end);
      }
    }

    removeDraftThreadFromThreadMap();
    this.currentTargetId = null;
    if (targetId) {
      this.api.createBlankThread(targetId).then((res) => {
        that.draftThread = res;
        that.draftThread.draft = true;
        that.draftThread.unread = false;
        that.draftThread.quotation = quotation;
        that.draftThread.comments = [];
        that.currentTargetId = targetId;
        addDraftThread();
        updateTargetExistence();

      that.activeCommentIdx = 0;
      that.updateCommentThreads(targetId);
      that.refreshBubbleButtons();

        if (!that.isSideCommentEnabled()) {
          $timeout(() => {
            const lowerComment = jQuery(`#comment-lower-${targetId}:visible`);
            if (lowerComment[0]) {
              jQuery('html,body').animate({
                scrollTop: lowerComment.offset().top - 20,
              });
              const field = lowerComment.find('.comment-field');
              if (field[0]) {
                field[0].focus();
              }
            }
          });
        }
      });
    }
  };

  this.removeDraftThread = function removeDraftThread() {
    that.draftThread = null;
    that.updateCommentButtons();
  };

  this.updateCommentThreads = function updateCommentThreads(targetId, threadIdx, nodeType) {
    if (that.currentTargetId !== targetId) {
      that.activeCommentIdx = threadIdx || 0;
    }
    that.currentTargetId = targetId;
    that.nodeType = nodeType;
  };

  this.refreshBubbleButtons = function refreshBubbleButtons() {
    jQuery('bulb-comment-button').remove();
    if (!that.commentThreadMap) {
      return;
    }

    if (that.editorType === 'ckeditor') {
      for (const targetId of Object.keys(that.commentThreadMap)) {
        const target = that.findCKETargetElement(targetId);
        if (target) {
          const nodeType = target.nodeName;
          const threadList = that.commentThreadMap[targetId];
          if (threadList && threadList.length > 0) {
            let threadCount = 0;
            if (that.showArchivedComments) {
              threadCount = threadList.length;
            } else {
              threadList.forEach((thread) => {
                if (!thread.archived) {
                  threadCount += 1;
                }
              });
            }
            if (threadCount) {
              const button = $compile(
                `<bulb-comment-button thread-count="${threadCount}" unit-id="${that.currentPage.unit.id
                }" editor-type="${that.editorType}" node-type="${nodeType}" target-id="${targetId
                }"></bulb-comment-button`,
              )($rootScope);
              $('.bulb-page-content').parent().prepend(button);
            }
          }
        }
      }
    } else {
      currentPageElement.children().each(
        function() {
          const targetId = $(this).attr('id');
          const threadList = that.commentThreadMap[targetId];
          if (threadList && threadList.length > 0) {
            let threadCount = 0;
            if (that.showArchivedComments) {
              threadCount = threadList.length;
            } else {
              threadList.forEach((thread) => {
                if (!thread.archived) {
                  threadCount += 1;
                }
              });
            }
            if (threadCount) {
              const button = $compile(
                `<bulb-comment-button thread-count=${threadCount} unit-id="${that.currentPage.unit.id
                }" target-id="${targetId}"></bulb-comment-button>`,
              )($rootScope);
              $('.bulb-page-content').parent().prepend(button);
            }
          }
        },
      );
    }
  };

  this.updateCommentButtons = function updateCommentButtons() {
    return that.api.getAllThreads().then(that.refreshBubbleButtons);
  };

  this.switchCommentThreadVisible = function switchCommentThreadVisible(targetId, threadIdx, nodeType) {
    that.draftThread = null;
    if (targetId === that.currentTargetId) {
      that.currentTargetId = null;
    } else {
      that.updateCommentThreads(targetId, threadIdx, nodeType);
    }
  };

  this.readComment = function readComment(thread, comment, duration) {
    if (!comment) {
      return;
    }
    $timeout(() => {
      if (!comment.unread) {
        return;
      }

      const { comments } = thread;
      // eslint-disable-next-line no-param-reassign
      comment.unread = false;
      that.api.markCommentRead(thread, comment.id);

      let threadUnread = false;
      for (const idx in comments) {
        if (comments[idx].unread) {
          threadUnread = true;
          break;
        }
      }
      // eslint-disable-next-line no-param-reassign
      thread.unread = threadUnread;
    }, duration);
  };

  this.getTargetElementPosition = function getTargetElementPosition(targetId) {
    let positionInformation;
    if (that.editorType === 'ckeditor') {
      const ckeTarget = that.findCKETargetElement(targetId);
      if (ckeTarget) {
        positionInformation = ckeTarget;
        positionInformation.top = ckeTarget.offsetTop;
      }
    } else {
      const target = jQuery(`#${targetId}`);
      let nodeName;
      if (target.children().children()[0]) {
        nodeName = target.children().children()[0].nodeName;
      }
      if (target[0]) {
        positionInformation = target.position();
        positionInformation.top += parseInt(target.css('marginTop'), 10);
        positionInformation.nodeName = (nodeName) || ''; // jshint ignore: line
      }
    }
    return positionInformation;
  };

  const checkPageContent = function checkPageContent(scope) {
    let lastNoIdCount;
    scope.$watch(() => {
      const array = [];
      for (let i = 0; i < currentPageElement.children().length - 1; i += 1) {
        const child = currentPageElement.children().eq(i);
        if (child.hasClass('bulb-content-trailer')) {
          continue;
        }
        const id = $(child).attr('id');
        if (!id) {
          array.push($(child));
        }
      }

      lastNoIdCount = array.length;
      return array.length;
    }, () => {
      if (lastNoIdCount) {
        that.getParagraphIds(lastNoIdCount).then((paragraphIds) => {
          let changed = false;
          for (let i = 0; i < currentPageElement.children().length - 1; i += 1) {
            if (!paragraphIds.length) {
              break;
            }

            const child = currentPageElement.children().eq(i);
            if (child.hasClass('bulb-content-trailer')) {
              continue;
            }
            const id = $(child).attr('id');
            if (!id) {
              const newId = paragraphIds.pop();
              $(child).attr('id', newId);
              changed = true;
            }
          }

          if (changed && that.editorType !== 'ckeditor') {
            // inform to editor
            that.currentMediumEditor.trigger('editableInput', null, currentPageElement[0]);
          }
        });
      }
    });

    if (that.currentPage.canEdit) {
      scope.$watch(() => {
        if (that.editorType === 'ckeditor') {
          const selector = document.querySelector('.ck-content');
          if (selector) {
            return selector.children.length;
          }
        } else {
          return currentPageElement.children().length;
        }
      }, () => {
        updateTargetExistence();
        that.refreshBubbleButtons();
      });
    }
  };

  this.getCurrentCommentThreads = function getCurrentCommentThreads() {
    if (!that.currentTargetId) {
      return null;
    }
    return that.commentThreadMap[that.currentTargetId];
  };

  this.isCommentable = function isCommentable(page) {
    const { currentUser } = BulbAuthService;
    return (page && page.unit.commentsEnabled && !BulbPresentationService.isFullScreen()
      && currentUser.isAuthenticated()
      && (page.unit.unitType === 'PublishedPageUnit' || page.unit.unitType === 'DraftPageUnit'));
  };

  /*
   * Only Educators, Admins and the page owner themselves can make private comments on pages
   */
  this.canMakePrivateComment = function canMakePrivateComment(page) {
    const { currentUser } = BulbAuthService;
    return currentUser.position === 'EDUCATOR'
      || currentUser.position === 'ADMINISTRATOR' || currentUser.hasPermission(page.unit, AUTH.PERMISSIONS.DELETE);
  };

  /**
     * It is used for grabbing cke media and non-media elements.
   *
     * @param targetId It is the id of element which will be returned.
     */
  this.findCKETargetElement = function findCKETargetElement(targetId) {
    return document.querySelector(`[bulb-block-id='${targetId}']`)
        || document.querySelector(`[bulb-id='${targetId}']`);
  };

  this.init = function init(page, elem, editor, scope, ckeditor) {
    this.currentTargetId = null;
    this.nodeType = null;
    this.commentThreadMap = null;
    this.commentable = this.isCommentable(page);
    this.threadComment = {};
    this.draftThread = null;
    this.currentPage = page;
    this.authorFlg = page.canEdit;
    this.lowerCommentExpanded = {};
    this.sideQuotationExpanded = {};
    this.lowerQuotationExpanded = {};
    this.currentMediumEditor = editor;
    currentPageElement = elem;
    this.editorType = ckeditor;

    if (scope) {
      checkPageContent(scope);
    }

    if (!this.commentable) {
      this.currentPage = null;
      return;
    }

    this.updateCommentButtons();
  };
}
